module.exports = __webpack_public_path__ + "img/five-four.fca8d4a1.png";